<script lang="ts">
  import { createForm } from 'svelte-forms-lib'
  import { DoubleBounce } from 'svelte-loading-spinners'
  import { CreateCheckoutSession } from '../utilities/backendApi'
  import { fieldErrorsOrUndefined } from '../utilities/forms'
  import * as T from 'io-ts'
  import { withMessage, NonEmptyString } from 'io-ts-types'
  import { sendEventToFirebase } from '../logging/events'
  import CtaButton from '../Generic/CtaButton.svelte'

  let initialValues: { name: string } = { name: '' }
  let message = ''
  let loading = false

  const FormT = T.type({
    name: withMessage(NonEmptyString, () => 'Your team has gotta have a name!'),
  })

  const { form, errors, touched, isValid, isSubmitting, handleChange, handleSubmit } = createForm({
    initialValues,
    validate: values => fieldErrorsOrUndefined(FormT, values), // No Partial as only one field.
    onSubmit: async (values: { name: string }) => {
      loading = true
      try {
        const response = await CreateCheckoutSession({ type: 'new', ...values })
        if (response.status == 'Ok') {
          sendEventToFirebase({ key: 'StartedCheckout' })
          window.location.href = response.url
        } else {
          message = response.message
        }
      } catch (err: unknown) {
        if (err instanceof Error) {
          console.error(err.message)
          message = 'Something has gone wrong.'
        }
      }
      loading = false
    },
  })

  touched.subscribe(() => (message = ''))
</script>

{#if loading}
  <div class="spinner">
    <DoubleBounce color="#4b4b4b" size="2" unit="em" />
  </div>
{/if}

<form on:submit={handleSubmit}>
  <label for="name">Team Name</label>
  <input id={'name'} name={'name'} on:change={handleChange} bind:value={$form.name} />
  <div class="submit">
    <CtaButton type="submit" disabled={!$isValid || $isSubmitting}>Continue to Payment</CtaButton>
  </div>
</form>
{#if $errors.name}
  <small> {$errors.name} </small>
{/if}
{#if message}
  <h2>{message}</h2>
{/if}

<style>
  .spinner {
    display: flex;
    position: absolute;
    justify-content: center;
    text-align: center;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    font-size: 60px;
  }

  form {
    display: grid;
    grid-template-columns: 10em 1fr;
    margin-top: 2em;
    align-items: center;
    grid-row-gap: 1em;
  }

  label {
    text-transform: uppercase;
    text-align: center;
    font-weight: 600;
  }

  .submit {
    grid-column: 1 / span 2;
  }
</style>
